// extracted by mini-css-extract-plugin
export default {"formBox":"PaymentItemForm_formBox__3k-44"};